module.exports = __webpack_public_path__ + "static/media/mobileCharlieMobileIcon.a213da1f.svg";